<template>
    <admin-header />
    <admin-menu />
    <div class="flex sm:ml-20 mt-8 dark:text-dark.textOnBkg">
        <font-awesome-icon icon="fas fa-arrow-left" class="text-2xl mr-5 cursor-pointer" @click="$router.push('/admin')" />
        <div class="cursor-pointer" @click="onlyActiveFunction">
            <div>
                <font-awesome-icon :icon="onlyActive.icon" /> Show only active
            </div>
        </div>
    </div>
    <div class="overflow-x-auto mx-auto mt-2 px-5 sm:pl-20 sm:pr-10">
        <div class="overflow-auto pb-20" style="height: calc(100vh - 155px);">
            <table class="bg-transparent dark:bg-dark.tableBG mt-3 mx-auto whitespace-nowrap rounded font-normal border border-sepBorder dark:border-dark.sepBorder table-auto w-full">
                <thead>
                    <tr class="top-0 sticky bg-gray-100 z-10 border border-sepBorder dark:border-dark.sepBorder dark:bg-dark.panels dark:text-dark.textOnBkg">
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">ID</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Name</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Creators</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center" title="Active employees">Employees</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">Subscription ID</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">Main email</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">Type</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">Phone number</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">Payment added</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">State</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">Next charge</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">Invoices</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Created</th>
                    </tr>
                </thead>
                <tbody v-if="filteredAgencies.length > 0">
                    <slot v-for="(agency, index) in filteredAgencies" :key="index">
                        <tr class="dark:bg-dark.tableBG dark:text-dark.textOnBkg" :class="{'bg-gray-100 dark:bg-dark.tableRow1': index%2 == 1, 'bg-red-200 border-2 border-red-400': agency.has_outstanding_invoices === 1}">
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{ agency.id }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{ agency.name }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center" :class="{'cursor-pointer': parseInt(agency.active_model_count+agency.inactive_model_count) > 0}" @click="openCreators(agency)">
                                <strong>{{ agency.active_model_count }} </strong>
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center" :class="{'cursor-pointer': parseInt(agency.active_user_count+agency.inactive_user_count) > 0}" @click="openEmployees(agency)"><strong>{{ agency.active_user_count }} </strong></td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">{{ agency.subscription_id }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">{{ agency.mainEmail }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap font-semibold" :class="{'text-growth': agency.type === 0}">{{ agency.type === 0 ? 'Agency' : 'Creator' }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">{{ agency?.phoneNumber ?? '-' }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">
                                <font-awesome-icon icon="fas fa-check" class="text-growth" v-if="agency.payment_added" />
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">
                                <div v-if="isTrialPeriod(agency.trial_end_date)" class="text-xs p-0.5 px-1 rounded bg-button text-white mx-1">Trial period</div>
                                <div v-if="agency.subscription_status_id === 1" class="text-xs p-0.5 px-1 rounded bg-growth text-white dark:text-black mx-1 mt-0.5">Active subscription</div>
                                <div v-if="agency.automated_billing === 0" class="text-xs p-0.5 px-1 rounded bg-orange-400 text-white dark:text-black mx-1">Active - manual billing</div>
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">
                                <slot v-if="agency.subscription_status_id === 1 || agency.automated_billing === 0">
                                    {{ agency.next_charge_date ? $moment(agency.next_charge_date).format("DD.MM.YYYY") : 'N/A' }}
                                </slot>
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">
                                <div class="p-1 px-2 cursor-pointer" @click="openInvoices(agency)"><font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" /></div>
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">{{ $moment(agency.createdAt).format('DD.MM.YYYY') }}</td>
                        </tr>
                    </slot>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="12" class="text-center py-16">
                            <font-awesome-icon icon="fas fa-spinner" class="animate-spin text-xl text-center dark:text-dark.textOnBkg" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <maz-dialog v-model="showInvoicesDialog" title="Invoices" :width="800">
        <table v-if="invoices.length > 0" class="table-auto w-full border-collapse border border-sepBorder dark:border-dark.sepBorder">
            <thead>
                <tr class="bg-gray-100 dark:bg-dark.panels dark:text-dark.textOnBkg">
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">ID</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Subscription ID</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Date From</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Date To</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Total Amount</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Created At</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Paid</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Paid At</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Type</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Currency</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Detail</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="invoice in invoices" :key="invoice.id" class="dark:bg-dark.tableBG dark:text-dark.textOnBkg">
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ invoice.id }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ invoice.subscription_id }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ $moment(invoice.date_from).format('DD.MM.YYYY') }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ $moment(invoice.date_to).format('DD.MM.YYYY') }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ invoice.total_amount }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ $moment(invoice.created_at).format('DD.MM.YYYY') }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">
                        <div class="flex items-center gap-1.5 text-center">
                            <font-awesome-icon :icon="invoice.paid ? 'fas fa-check' : 'fas fa-times'" :class="invoice.paid ? 'text-growth' : 'text-red-500'" />
                            <MazBtn v-if="!invoice.paid" @click="markInvoiceAsPaid(invoice.id)" outline class="ml-1" size="mini">Set as paid</MazBtn>
                        </div>
                    </td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ invoice.paid_at ? $moment(invoice.paid_at).format('DD.MM.YYYY') : '-' }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ invoice.type }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ invoice.currency }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">
                        <div class="cursor-pointer p-1 px-2" @click="showInvoiceDetail(invoice)"><font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" /></div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else class="text-center py-4">No invoices available.</div>
    </maz-dialog>
    <maz-dialog v-model="showInvoiceDetailDialog" title="Invoice Details" :width="800">
        <table v-if="invoiceDetail && invoiceDetail.invoice_items.length > 0" class="table-auto w-full border-collapse border border-sepBorder dark:border-dark.sepBorder">
            <thead>
                <tr class="bg-gray-100 dark:bg-dark.panels dark:text-dark.textOnBkg">
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Name</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Platform</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Total Days</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Proxy</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Total Cost</th>
                    <th class="border border-sepBorder dark:border-dark.sepBorder p-2">Tools</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in invoiceDetail.invoice_items" :key="item.model_pair_id" class="dark:bg-dark.tableBG dark:text-dark.textOnBkg">
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ item.name }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ item.platform }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ item.total_days }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ item.proxy ? 'Yes' : 'No' }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">{{ item.total_cost.toFixed(2) }}</td>
                    <td class="border border-sepBorder dark:border-dark.sepBorder p-2">
                        <ul>
                            <slot v-for="tool in item.tools" :key="tool.tool_id">
                                <li v-if="tool.final_cost>0">
                                    Tool ID: {{ tool.tool_id }}, Price: {{ tool.price }}, Period: {{ tool.period }}, Final Cost: {{ tool.final_cost }}
                                </li>
                            </slot>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else class="text-center py-4">No details available for this invoice.</div>
    </maz-dialog>
</template>

<script setup>
    import adminHeader from '@/components/admin/AdminHeader.vue';
    import adminMenu from '@/components/admin/AdminMenu.vue';
</script>
  
<script>
    import { getAgencies, get_invoices, mark_invoice_paid, get_invoice_detail } from '@/api/admin_api';
    export default {
        name: 'AgenciesDashboard',
        data() {
            return {
                agencies_list: [],
                onlyActive: {
                    icon: 'far fa-square',
                    active: false
                },
                showInvoicesDialog: false,
                invoices: [],
                showInvoiceDetailDialog: false,
                invoiceDetail: null
            };
        },
        computed: {
            filteredAgencies() {
                if (this.onlyActive.active) {
                    return this.agencies_list.filter(agency => agency.subscription_status_id === 1 || agency.automated_billing == 0);
                }
                return this.agencies_list;
            }
        },
        methods: {
            async markInvoiceAsPaid(invoiceId) {
                let invoiceMark = await mark_invoice_paid(this.$cookies.get('admin_auth_token'), invoiceId);
                if (invoiceMark) {
                    this.invoices = this.invoices.map(invoice => {
                        if (invoice.id === invoiceId) {
                            invoice.paid = true;
                            invoice.paid_at = new Date().toISOString();
                        }
                        return invoice;
                    });
                }
            },
            openCreators(agency) {
                if (!(parseInt(agency.active_model_count + agency.inactive_model_count) > 0)) { return; }
                this.$router.push({ 'path': '/admin/creators', 'query': { 'company': agency.id } });
            },
            openEmployees(agency) {
                if (!(parseInt(agency.active_user_count + agency.inactive_user_count) > 0)) { return; }
                this.$router.push({ 'path': '/admin/employees', 'query': { 'company': agency.id } });
            },
            onlyActiveFunction() {
                this.onlyActive.active = !this.onlyActive.active;
                this.onlyActive.icon = this.onlyActive.active ? 'fas fa-check-square' : 'far fa-square';
            },
            isTrialPeriod(trialEndDate) {
                return this.$moment(trialEndDate).isSameOrAfter(this.$moment());
            },
            async openInvoices(agency) {
                try {
                    this.invoices = await get_invoices(this.$cookies.get('admin_auth_token'), agency.id);
                    this.showInvoicesDialog = true;
                } catch (error) {
                    console.error('Failed to fetch invoices:', error);
                }
            },
            async showInvoiceDetail(invoice) {
                try {
                    const invoiceDetail = await get_invoice_detail(this.$cookies.get('admin_auth_token'), invoice.id);
                    this.invoiceDetail = invoiceDetail;
                    this.showInvoiceDetailDialog = true;
                } catch (error) {
                    console.error('Failed to fetch invoice detail:', error);
                }
            }
        },
        async created() {
            this.agencies_list = await getAgencies(this.$cookies.get('admin_auth_token'));
        }
    };
</script>